import React, { useState } from "react";
import logo from "../../resource/7.png";
import CommonFormFields from "./CommonFormFields";
import useFormHandler from "../../Hook/useFormHandler";

const SanghaFundForm = () => {
const initialValues = {
    // Personal Information
    firstName: "",
    lastName: "",

    // Address Information
    address: "",
    city: "",
    postal_code: "",
    residential_address: "",

    // Contact Information
    mobileNumber: "",
    wtNumber: "", // This will map to whatsapp_number
    email: "",

    // Additional Information
    queries: "",

    ip_address: "",
  };
  const validations = {
    // Personal Information
    firstName: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "First Name should contain only letters, spaces, or hyphens",
    },
    lastName: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "Last Name should contain only letters, spaces, or hyphens",
    },

    // Address Information
    address: {
      required: true,
      minLength: 5,
      message: "Address must be at least 5 characters long",
    },
    city: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "City should contain only letters, spaces, or hyphens",
    },
    postal_code: {
      required: true,
      pattern: /^\d{5,10}$/,
      message: "Postal Code should be 5 to 10 digits",
    },
    residential_address: {
      required: true,
      minLength: 5,
      message: "Residential address must be at least 5 characters long",
    },

    // Contact Information
    mobileNumber: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "Mobile Number should be 10 to 15 digits, with optional '+'",
    },
    wtNumber: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "WhatsApp Number should be 10 to 15 digits, with optional '+'",
    },
    email: {
      required: true,
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Invalid email format",
    },

    // Additional Information
    queries: {
      required: false,
      maxLength: 1000,
      message: "Queries cannot exceed 1000 characters",
    },
  };

  const endpoint = '/create-sangha-fund-requests';

  const transformForApi = (data) => ({
    // Personal Information
    first_name: data.firstName,
    last_name: data.lastName,

    // Address Information
    address: data.address,
    city: data.city,
    postal_code: data.postal_code,
    residential_address: data.residential_address,

    // Contact Information
    mobile_number: data.mobileNumber,
    whatsapp_number: data.wtNumber,
    email_address: data.email,

    // Additional Information
    queries: data.queries,
    ip_address: data.ip_address,
  });

  const {
    formData,
    errors,
    loading,
    handleInputChange,
    handleSubmit,
    setFormData,
  } = useFormHandler({
    initialValues,
    validations,
    endpoint,
    includeIP: true,
    transformFn: transformForApi,
  });
  return (
    <div className="form-page dark-gold ">
        <form onSubmit={handleSubmit}>
          <div className="form-title">
            <img src={logo} alt="" width={200} />
            <div className="details">
              <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
              <h2 className="h4">Sangha Fund Request Form  </h2>
            </div>
          </div>

 <p className="font-p mt-6">
          Please fill in the following details and we will contact you.
        </p>
        <p className="font-p mt-5">Full Name *</p>

        {/* Common form fields */}
        <CommonFormFields
          formData={formData}
          handleInputChange={handleInputChange}
          errors={errors}
        />

        <p className="font-p mt-5">Address *</p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
            <label htmlFor="address">Full Address</label>
            {errors.address && <span className="error">{errors.address}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
            />
            <label htmlFor="city">City *</label>
            {errors.city && <span className="error">{errors.city}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="postal_code"
              name="postal_code"
              value={formData.postal_code}
              onChange={handleInputChange}
            />
            <label htmlFor="postal_code">Postal Code *</label>
            {errors.postal_code && (
              <span className="error">{errors.postal_code}</span>
            )}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="residential_address"
              name="residential_address"
              value={formData.residential_address}
              onChange={handleInputChange}
            />
            <label htmlFor="residential_address">Residential Address *</label>
            {errors.residential_address && (
              <span className="error">{errors.residential_address}</span>
            )}
          </div>
        </div>

          <p className="font-p mt-5">
          Please indicate any questions you would like to clarify regarding the Sangha Fund Donation. 
          </p>

         <div className="form-item mt-4">
          <textarea
            id="queries"
            name="queries"
            value={formData.queries}
            onChange={handleInputChange}
            rows="6"
          />
          <label htmlFor="queries"></label>
          {errors.queries && <span className="error">{errors.queries}</span>}
        </div>

        {/* Submit button */}
        <button
          type="submit"
          id="submitbtn"
          className="mt-5"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

          <p className="font-p mt-5 pb-4">
          We greatly appreciate your interest in joining the Sangha  Fund at Bhaddeka Vihari Monastery. 
          </p>
        </form>
      </div>
  )
}

export default SanghaFundForm